import { render, staticRenderFns } from "./Retur.vue?vue&type=template&id=c867ed76&"
import script from "./Retur.vue?vue&type=script&lang=js&"
export * from "./Retur.vue?vue&type=script&lang=js&"
import style0 from "./Retur.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports